import { alternativeStartDelete } from '../actions/alternativeActions';
import { assistanceStartDelete } from '../actions/assistanceActions';
import { experienceStartDelete } from '../actions/experienceActions';
import { financialStartDelete } from '../actions/financialActions';
import { innovationStartDelete } from '../actions/innovationActions';
import { regulationStartDelete } from '../actions/regulationActions';
import { technologyStartDelete } from '../actions/technologyActions';
import { visionStartDelete } from '../actions/visionActions';

const DELETE_THUNKS = {
  technology: technologyStartDelete,
  alternative: alternativeStartDelete,
  experience: experienceStartDelete,
  innovation: innovationStartDelete,
  assistance: assistanceStartDelete,
  financial: financialStartDelete,
  vision: visionStartDelete,
  regulation: regulationStartDelete
};

export const startDeleteModuleRecord = (process, id, onDeleted) => {
  const thunk = DELETE_THUNKS[String(process || '').toLowerCase()];
  if (!thunk || !id) {
    return () => {};
  }
  return thunk(id, onDeleted);
};
